import i18n from '@/langs'
import reviewsRu from '@/langs/ru/reviews'
import reviewsEn from '@/langs/en/reviews'

// Начальное состояние
const state = {
	reviews: {
		ru: reviewsRu,
		en: reviewsEn,
	},
}

// Синхронные изменения состояний
const mutations = {}

// Геттеры
const getters = {
	reviewsByLocale: (state) => {
		return state.reviews[i18n.locale]
	},
}

// Асинхронные изменения
const actions = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
